import React from 'react';
import ReactDOM from 'react-dom';

class Input extends React.Component {
  constructor(props) {
    super(props);
    this.fileInput = React.createRef();
  }

  openFileFinder() {
    this.fileInput.click();
  }

  render() {
    const root = window.document.getElementsByTagName('body')[0];
    return ReactDOM.createPortal(
      <input
        type='file'
        onChange={this.props.onChange}
        accept={['.jpg', '.png']}
        ref={(el) => { this.fileInput = el; }}
        hidden
      />,
      root
    );
  }
}

export default Input;
